import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV163() {
  return (
    <ReleaseCard version="v1.6.3" date="1st October 2025" title="Performance optimization and fine-tuning!">
      <p className="text-gray-300 mb-4">We're seeing quite heavy usage on our back end engine that coordinates all game timers, we thought it vitally important we focus on performance for this aspect of the application so we reviewed the algorithms that deliver timing updates and notification to all your devices! This was the main focus on this latest release, we didn't think we could squeeze any more performance out of our Java engine but we were wrong, she's been fine tuned now - to perfection!!</p>
      <p className="text-gray-300 mb-4">We also managed to squeeze some more improvements into this version that we hope you will enjoy:</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        <li>• Improved performance for message sending</li>
        <li>• New user preference capabilities added</li>
        <li>• New refresh button on Venues page if error fetching venues</li>
        <li>• Notifications not sent if device is in low power mode</li>
      </ul>
      <p className="text-purple-400 font-medium">Keep the feedback coming team!</p>
    </ReleaseCard>
  );
}
